import React from "react";
import PropTypes from "prop-types";

import { useStore } from "../../../../stores/AppStore";
import { useRouter } from "../../../common/hooks/useRouter";
import { useQuery } from "react-query";

import MobilePaginateButtons from "../../../../../components/Common/Layout/MobilePaginateButtons/MobilePaginateButtons";
import { EmptyFilterSearch, ErrorMessagesPage, PageHeader } from "../index";

import { Box, Paginate } from "shipnow-mercurio";

import {
  LIST_DUMB,
  LIST_REFRESH_INTERVAL,
} from "../../../common/constants/settings.consts";

const DEFAULT_PROPS = {
  topComponent: null,
  filterComponent: null,
  pageHeaderBtnsGroup: null,
  query: () => {},
  queryStats: null,
  name: "",
  tableComponent: null,
  tabsComponent: null,
  title: "title",
  emptyContent: null,
  isMobile: false,
};

export const ListPageLayout = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };

  const store = useStore();
  const topRef = React.useRef();

  const router = useRouter();

  const query = useQuery({
    queryKey: attrs.query.key,
    queryFn: () => attrs.query.fn(router.query),
    refetchInterval: LIST_REFRESH_INTERVAL,
  });

  const queryStats = useQuery({
    queryKey: attrs.queryStats?.key,
    queryFn: () => attrs.queryStats?.fn(router.query),
    refetchInterval: LIST_REFRESH_INTERVAL,
    enabled: !!attrs.queryStats,
  });

  const handlePageChange = (sender, page) => {
    topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

    router.pushHistory({ ...router.query, page });
  };

  if (query.isFetching || queryStats.isFetching) {
    return (
      <>
        <PageHeader
          breadcrumbsProps={{ currentLabel: attrs.title }}
          sectionHeader={{
            titleProps: { children: attrs.title },
          }}
          padding="b-0 t-8"
        />

        {attrs.tableComponent && (
          <attrs.tableComponent list={LIST_DUMB} isLoading />
        )}
      </>
    );
  }

  if (query.isError) {
    return <ErrorMessagesPage error={query.error} />;
  }

  return (
    <div ref={topRef}>
      <PageHeader
        breadcrumbsProps={{ currentLabel: attrs.title }}
        sectionHeader={{
          titleProps: { children: attrs.title },
          buttonsGroup: () =>
            attrs.pageHeaderBtnsGroup && (
              <attrs.pageHeaderBtnsGroup stats={queryStats.data} />
            ),
        }}
        padding="b-0 t-8"
      />

      {!attrs.queryStats || queryStats.data.total.exists ? (
        <>
          {!!attrs.topComponent && <attrs.topComponent />}

          {!!attrs.filterComponent && (
            <attrs.filterComponent stats={queryStats.data} />
          )}

          {!!attrs.tabsComponent && (
            <attrs.tabsComponent stats={queryStats.data} />
          )}

          {query.data?.results?.length === 0 ? (
            <EmptyFilterSearch />
          ) : (
            <>
              {!!attrs.tableComponent && (
                <attrs.tableComponent
                  list={query.data.results}
                  dataHeaders={query.data.headers}
                  paginate={query.data.paginate}
                />
              )}

              <Box
                padding={`t-16 ${
                  store.user.loggedInUser.hasChatSupport ? "b-62" : "b-32"
                }`}
              >
                {attrs.isMobile ? (
                  <MobilePaginateButtons
                    onClick={handlePageChange}
                    paginate={query.data.paginate}
                  />
                ) : (
                  <Paginate
                    onChange={handlePageChange}
                    page={query.data.paginate.page}
                    pages={query.data.paginate.pages}
                  />
                )}
              </Box>
            </>
          )}
        </>
      ) : (
        <>{!!attrs.emptyContent && <attrs.emptyContent />}</>
      )}
    </div>
  );
};

ListPageLayout.propTypes = {
  topComponent: PropTypes.func,
  filterComponent: PropTypes.func,
  pageHeaderBtnsGroup: PropTypes.func,
  query: PropTypes.shape({
    fn: PropTypes.func.isRequired,
    key: PropTypes.array.isRequired,
  }).isRequired,
  queryStats: PropTypes.shape({
    fn: PropTypes.func.isRequired,
    key: PropTypes.array.isRequired,
  }),
  name: PropTypes.string.isRequired,
  tableComponent: PropTypes.func,
  tabsComponent: PropTypes.func,
  title: PropTypes.string.isRequired,
  emptyContent: PropTypes.func,
  isMobile: PropTypes.bool,
};
